const getElement = (selector) => document.querySelector(selector);

const dismissButtonSelector = '.dismiss-ada-chatbot';
const getDismissButton = () => getElement(dismissButtonSelector);

const adaRootSelector = '#ada-entry';
const getAdaRoot = () => getElement(adaRootSelector);

const buttonFrameSelector = '#ada-button-frame';
const getButtonFrame = () => getElement(buttonFrameSelector);

const infoFrameSelector = '#ada-info-frame';
const getInfoFrame = () => getElement(infoFrameSelector);

const chatFrameSelector = '#ada-chat-frame';
const getChatFrame = () => getElement(chatFrameSelector);

const privacyPolicySelector = '.lds__privacy-policy:not(.lds__privacy-policy__closed)';
const getPrivacyPolicy = () => getElement(privacyPolicySelector);

const privacyPolicyCloseButtonSelector = '.lds__privacy-policy__btnClose';
const getPrivacyPolicyCloseButton = () => getElement(privacyPolicyCloseButtonSelector);

module.exports = {
  dismissButtonSelector,
  getDismissButton,
  adaRootSelector,
  getAdaRoot,
  buttonFrameSelector,
  getButtonFrame,
  infoFrameSelector,
  getInfoFrame,
  chatFrameSelector,
  getChatFrame,
  privacyPolicySelector,
  getPrivacyPolicy,
  privacyPolicyCloseButtonSelector,
  getPrivacyPolicyCloseButton,
};
